var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralOutsideTemperatureSensor = function SvgDAhuGeneralOutsideTemperatureSensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 18.5,
    width: 27,
    height: 27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,19v26H5v-26h26M32,18H4v28h28v-28h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 20.69,
    width: 3.88,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 23.81,
    width: 3.05,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 26.93,
    width: 3.88,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 30.06,
    width: 3.05,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 33.18,
    width: 3.88,
    height: 0.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.39 26.34 13.39 26.18 13.34 26.15 13.39 26.34",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.96,35.22v-13.78h-3.82v13.78c-1.2.67-2.01,1.96-2.01,3.43,0,2.16,1.76,3.92,3.92,3.92s3.92-1.76,3.92-3.92c0-1.47-.81-2.75-2.01-3.43h0ZM16.05,41.42c-1.54,0-2.78-1.25-2.78-2.78,0-1.11.65-2.06,1.59-2.51v-5.61h2.39v5.61c.94.45,1.59,1.4,1.59,2.51,0,1.54-1.25,2.78-2.78,2.78h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,36.13v-5.61h-2.39v5.61c-.94.45-1.59,1.4-1.59,2.51,0,1.54,1.25,2.78,2.78,2.78s2.78-1.25,2.78-2.78c0-1.11-.65-2.06-1.59-2.51ZM17.42,40l-.53-.53c.23-.23.35-.52.35-.84s-.12-.62-.35-.84l.53-.53c.37.37.57.85.57,1.37s-.2,1.01-.57,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71,34.8v-14.11h-5.32v14.11c-1.22.84-2.01,2.25-2.01,3.84,0,2.58,2.09,4.67,4.67,4.67s4.67-2.09,4.67-4.67c0-1.59-.8-3-2.01-3.84h0ZM16.05,42.57c-2.16,0-3.92-1.76-3.92-3.92,0-1.47.81-2.75,2.01-3.43v-13.78h3.82v13.78c1.2.67,2.01,1.95,2.01,3.43,0,2.16-1.76,3.92-3.92,3.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.89,37.79c.23.23.35.52.35.84s-.12.62-.35.84l.53.53c.37-.37.57-.85.57-1.37s-.2-1.01-.57-1.37l-.53.53Z",
    fill: "#fff"
  })))))));
};
export default SvgDAhuGeneralOutsideTemperatureSensor;